const MANAGEMENT_COMPANIES_PERMISSIONS = {
	WORKFORCE_ACTION_VIEW: 'WORKFORCE_PAGE.ACTION.VIEW',
	REOPEN_CANCELLED_SLOT: 'GLOBAL_CALENDAR_VIEW.FLEX_SHIFTS.ACTION.REOPEN',
	WORKFORCE_PROFESSIONAL_EDIT: 'WORKFORCE_PAGE.PROFESSIONAL.EDIT',
	WORKFORCE_PROFESSIONAL_VIEW: 'WORKFORCE_PAGE.PROFESSIONAL.PROFILE.VIEW',
	FACILITY_FLEX_FLOAT: 'FACILITY.FLEX_SHIFTS.ACTION.FLOAT',
	SETTINGS_PAGE_VIEW: 'SETTINGS.PAGE.VIEW',
	PORTAL_CREATE_FLEX_PAST_SHIFTS: 'PORTAL.FLEX.CREATE_PAST_SHIFTS',
	FLEX_SPLIT_SHIFT: 'FLEX_SHIFTS.ACTION.SPLIT'
};

export default MANAGEMENT_COMPANIES_PERMISSIONS;
